import { render } from "./HelpFormGetHelp.vue?vue&type=template&id=63f03f06&scoped=true"
import script from "./HelpFormGetHelp.vue?vue&type=script&lang=js"
export * from "./HelpFormGetHelp.vue?vue&type=script&lang=js"

import "./HelpFormGetHelp.vue?vue&type=style&index=0&id=63f03f06&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f03f06"]])

export default __exports__